// Přepínače funkcí per instance (Shoptet projekt).
//
// PROČ (rozhodnutí Tomáše 2026-09-22): `main` je vždy nasaditelný na ostrou.
// Funkce, která na ostrou ještě nesmí (čeká na datum, na data, na konec
// placeného doplňku), se merguje sem vypnutá pro ostrou; zapnutí je samostatný
// malý commit + deploy. Do té doby #396 (řádek „Hodí se k tomu" v košíku) držel
// deploy #406 na ostrou deset dní.
//
// Rozhoduje `projectId` z `dataLayer[0].shoptet` (serverově vyrenderovaný, je
// tu dřív než náš JS), ne hostname: dev má víc domén, Bender běží na localhost.
// Offline fixtures `dev/*.html` nesou 797093 → harnessy vidí stav dev.
// Neznámý projekt i chybějící dataLayer = vypnuto. Testovací instance
// (dev, sk-dev) mají hodnoty shodné, ostré (live, sk) taky.

// TODO(new-shop): projekty instancí (klíče = tabulka INSTANCES nástrojů)
export const PROJECTS = { dev: 797093, live: 585781, sk: 591524, 'sk-dev': 818282 };

export const FEATURES = {
  // Řádek „Hodí se k tomu" pod položkou košíku + tiché přidání z rozbalených
  // Souvisejících (cartCrossSell.js, #396). Ostrá zapnutá 1. 10. po úklidu výplně
  // enginu vazeb (reporting-saas #2225, 30. 9.) jako náhrada doplňku „Upsell
  // a cross sell" (plán fáze 3). SK jen kvůli paritě: Související tam nejsou,
  // řádek se nevykreslí. Cenový strop upsellu na detailu přepínač nemá, platí všude.
  cartXsell: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Ikona dopravy zdarma na detailu (freeShipMark.js, mock C schválený Tomášem
  // 2026-09-23). Zapnuté i pro ostrou CZ a SK v T-1 (runbook-sk.md Fáze 1 bod 0);
  // na zákazníky dorazí až nasazením v den D SK 25. 9. po odebrání ručního
  // příznaku „Doprava zdarma/zadarmo" (krok 3d, CZ deploy 3e, SK zápis 4).
  // Deploy na ostrou CZ před krokem 3d by ukázal štítek i ikonu vedle sebe.
  freeShipMark: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // „Naskladnění očekáváme do …" u vyprodaného zboží (restockDate.js, handover
  // reporting-saas 2026-09-24): detail + karty z `/specs` → `restock`. Ostrá CZ
  // i SK zapnuté 24. 9. po ověření na dev s reálným nočním souborem (KD4134 → „do
  // 30. 9."); na SK se projeví až dnem D (krok 4, do té doby stará šablona bundle nenačítá).
  restockDate: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Live chat SupportBoxu místo Smartsuppu (supportChat.js, supportbox-jipos #8).
  // Ostrá zapnutá 3. 10. 2026 (souhlas Tomáše), týž den na jeho pokyn stažená
  // (#483: po zavření okna křížkem zůstala bublina SupportBoxu přes Košík) a večer
  // s opravou zavření, chatem ve spodní liště a vstupy na detailu znovu zapnutá
  // („Merge a zapni", #484). SK jen kvůli paritě: chat nemá (manifest `chat` null).
  supportChat: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Mobilní okno chatu bez zámku scrollu widgetu (`body.sb_mobile`, _support-chat.scss):
  // se sbalenou lištou prohlížeče mělo okno nahoře a dole prázdný pruh (iPhone
  // Tomáše 4. 10.). Klávesnici iOS ani sbalování lišty Playwright nenasimuluje;
  // ostrá zapnutá týž den na pokyn Tomáše bez zkoušky na telefonu („Spust deploy
  // na ostrou s opravou chatu"). Vrátí-li se posun okna s klávesnicí, vypnutí na
  // ostré = přepínač + deploy. SK chat nemá, parita s CZ.
  chatKeepScroll: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Akce PPL na výdejní místo do 10 kg za 19 Kč, 12.–25. 10. 2026 (#322,
  // manifest `shipping.promo`): promo pruh, pruh na detailu, modal dopravy,
  // karta hera, podtitul homepage, Doprava a platba a škála pásem. Šablona
  // o akci mluví jen v okně akce A se zapnutým přepínačem; okno se rozsvítí
  // 12. 10. 00:00 a zhasne 25. 10. 23:59:59 samo. Ostrá zapnutá dopředu
  // 7. 10. (Tomáš: „chci, aby se vše přepnulo automaticky"): ceník adminu
  // (tarif `akce-ppl-19`) přepíná plánovač .github/workflows/cenik-akce.yml
  // 11. 10. 20:00, tedy PŘED startem okna, a vrací 26. 10. 00:10, po jeho konci;
  // web tak nikdy nesliboval 19 Kč, které by pokladna neúčtovala.
  // SK akci nemá (`promo: []`), přepínač jen kvůli paritě s ostrou CZ.
  pplBox19: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Zvýrazněné recenze na detailu (recenze U3, reviewHighlights.js, rozhodnutí
  // Tomáše 6. 10.: karta „Recenze zákazníků" pod galerií + citát u názvu). Data
  // nese `/specs?reviews=<kód>` z denního jobu recenzí na s1 (U1); bez nich se nic
  // nekreslí. Ostrá zapnutá 6. 10. 2026 večer na pokyn Tomáše, po nasazení API na s1
  // (`reviews.shop`) a zveřejnění stránky „Jak recenze ověřujeme" (odkaz z karty,
  // § 5a odst. 5 ZOS). SK data nemá (tenant bez `reviews_file`), přepínač jen kvůli
  // paritě s CZ.
  reviewHighlights: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Karta recenzí na detailu, rozšíření U3b (rozhodnutí Tomáše 7. 10.): patro 3
  // „Hodnocení obchodu Jipos.cz" u produktu bez citovatelné recenze i bez hodnocení
  // od kupujících a výplň druhého místa karty s jedinou citací (kupující → obchod).
  // Citace a skóre obchodu jsou data patičky (reviews.js `loadReviews`), žádný další
  // dotaz. Ostrá zapnutá 7. 10. 2026 po OK Tomáše ke screenshotům a nové větě stránky
  // „Jak recenze ověřujeme"; SK data nemá, parita s CZ.
  reviewHighlightsShop: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Deštník „Říjnový výprodej" nad kategorií akční nabídky (plán kampaní 6. 10.
  // 2026, manifest `campaigns`, campaign.js): promo pruh, menu, homepage, štítky,
  // pás ve výpisu, popisek u ceny. Okno zhasne samo 31. 10. 23:59:59. Ostrá CZ
  // i SK zapnutá 6. 10. 2026 večer na pokyn Tomáše (výprodej běží, ceny jsou přepsané).
  campaignOctSale: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Deštník „Black Friday" 1.–30. 11. 2026 (vlna B plánu kampaní, manifest
  // `campaigns` id `blackFriday`): černý tón pruhu, menu, hera, zóny, bento a pásu
  // výpisu, banner pod nákupní kartou, pruh úspory v košíku (mocky M13–M17 schválené
  // 19. 10.). Všechno včetně vizuálu karty 0 hera a přednačteného posteru v hlavičce
  // řídí okno (campaign.js campaignHeroWindows): rozsvítí se 1. 11. 00:00 a zhasne
  // 30. 11. 23:59:59 samo. Ostrá CZ i SK zapnutá dopředu 19. 10. 2026 (Tomáš: kampaň
  // se má zapnout i vypnout sama, bez deploye v den startu); média `codex_20261019_bf*`
  // musí na ostrou před 1. 11.
  campaignBlackFriday: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Sekce hodnocení v patičce bere čísla platforem z `/reviews/summary` a citace
  // podle typu stránky z `/reviews/context` (recenze U2, reviews.js, mock schválený
  // Tomášem 6. 10. 2026). Vypnuto = čísla a citace jen ze zálohy v manifestu
  // (tvar sekce je stejný, mění se jen data). Ostrá CZ i SK zapnutá 7. 10. 2026 po
  // ověření nasazeného buildu na dev s živým API (devcheck reviews-footer 26/26,
  // --real 14/14); SK data nemá (tenant bez `reviews_file`), přepínač kvůli paritě.
  reviewsApi: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Procházení výprodeje z vlastního indexu (saleBrowse.js, plátno
  // docs/design/2026-10-07-vyprodej-prochazeni/ schválené 7. 10. 2026): na stránce
  // akční nabídky dlaždice kořenů s počty, čipy podkategorií, filtr sleva / cena /
  // značky / poslední kusy a řazení z `GET /browse`, stav v adrese. Vypnuto =
  // nativní výpis kategorie beze změny. Ostrá CZ i SK zapnutá 7. 10. 2026 večer na
  // pokyn Tomáše („pak zapni") po nasazení indexu a API na s1: `/browse` CZ 613 =
  // nativní `/slevoakce/` 613 položek, SK 614 vs. `/zlavoakcia/` 613, brána kostry
  // +34/+51 ms na dev. SK bez žluté dlaždice (výprodej skladu nemá).
  saleBrowse: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
  // Samoobslužné storno nezaplacené objednávky na stránce Stav objednávky (orderStatusPage.js
  // buildAbort, API `order-status/cancel`, úkol Dispečinku JIPOS-STORNO-SAMOOBSLUHA). Ostrá CZ
  // i SK zapnutá 18. 10. 2026 konzervativně (pokyn Tomáše): storno jen z fáze přijato,
  // nezaplacené (Čeká na platbu, Připomínka platby); nezaplacenou K expedici probere Tomáš
  // s klientem (PRO-VERONIKU). Seznam stavů nese `order_status.cancel` tenantu
  // v search/data/tenants.json, vypnutí na webu je tenhle přepínač + deploy.
  orderCancel: { [PROJECTS.dev]: true, [PROJECTS.live]: true, [PROJECTS.sk]: true, [PROJECTS['sk-dev']]: true },
};

/** `projectId` e-shopu z dataLayeru, jinak `null`. */
export function projectId() {
  try {
    const first = window.dataLayer && window.dataLayer[0];
    const id = first && first.shoptet && first.shoptet.projectId;
    return id ? Number(id) : null;
  } catch (e) {
    return null;
  }
}

/** Je funkce `name` zapnutá pro projekt `id` (výchozí = aktuální stránka)? */
export function featureOn(name, id) {
  const table = Object.prototype.hasOwnProperty.call(FEATURES, name) ? FEATURES[name] : null;
  if (!table) return false;
  const project = arguments.length > 1 ? id : projectId();
  return Object.prototype.hasOwnProperty.call(table, project) && table[project] === true;
}
